import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Observable } from 'rxjs';

import { IdDescription } from '../../../../tms-shared';
import { AddressService } from '../../../services/edit-create/address/address.service';
import { CountryReferenceService } from '../../../services/reference/country-reference.service';
import { CustomerSubTypeReferenceService } from '../../../services/reference/customer-sub-type-reference.service';
import { CustomerTypeReferenceService } from '../../../services/reference/customer-type-reference.service';
import { SalesDiscountReferenceService } from '../../../services/reference/sales-discount-reference.service';
import { SalesRegionReferenceService } from '../../../services/reference/sales-region-reference.service';
import { TmsFormlyService } from '../../../services/formly/tms-formly.service';

@Component({
  selector: 'app-address-details',
  templateUrl: './address-details.component.html',
  styleUrl: './address-details.component.scss',
})
export class AddressDetailsComponent implements OnInit {
  @Input() closeOnSave = true;
  @Input() id: string;
  @Output() saved = new EventEmitter<any>();

  fields: FormlyFieldConfig[];

  private countries$: Observable<IdDescription[]>;
  private salesRegion$: Observable<IdDescription[]>;
  private salesDiscount$: Observable<IdDescription[]>;
  private customerType$: Observable<IdDescription[]>;
  private customerSubType$: Observable<IdDescription[]>;

  constructor(
    public addressService: AddressService,
    private countryReferenceService: CountryReferenceService,
    private salesRegionReferenceService: SalesRegionReferenceService,
    private salesDiscountReferenceService: SalesDiscountReferenceService,
    private customerTypeReferenceService: CustomerTypeReferenceService,
    private customerSubTypeReferenceService: CustomerSubTypeReferenceService,
    private formlyService: TmsFormlyService,
  ) {}

  ngOnInit() {
    this.getReferenceData();
    this.getFields();
  }

  private getReferenceData() {
    this.countries$ = this.countryReferenceService.get();
    this.salesRegion$ = this.salesRegionReferenceService.get();
    this.salesDiscount$ = this.salesDiscountReferenceService.get();
    this.customerType$ = this.customerTypeReferenceService.get();
    this.customerSubType$ = this.customerSubTypeReferenceService.get();
  }

  private getFields() {
    this.fields = this.formlyService.twoColumnGrid(
      [
        this.formlyService.text('addressee', $localize`Addressee`, undefined, { maxLength: 60 }),
        this.formlyService.text('name', $localize`Name`, undefined, { maxLength: 60 }),
        this.formlyService.addressLookup('addressLookup', this.countries$),
        this.formlyService.text('line1', $localize`Address Line 1`, undefined, { required: true, maxLength: 80 }),
        this.formlyService.text('line2', $localize`Address Line 2`, undefined, { maxLength: 80 }),
        this.formlyService.text('line3', $localize`Address Line 3`, undefined, { maxLength: 80 }),
        this.formlyService.text('line4', $localize`Address Line 4`, undefined, { maxLength: 80 }),
        this.formlyService.text('townCity', $localize`Town/City`, undefined, { maxLength: 80 }),
        this.formlyService.text('region', $localize`Region`, undefined, { maxLength: 80 }),
        this.formlyService.text('postCode', $localize`Postcode`, undefined, { maxLength: 80 }),
        this.formlyService.select('countryId', $localize`Country`, this.countries$, undefined, { required: true }),
        this.formlyService.text('phone', $localize`Telephone`, undefined, { maxLength: 30 }),
        this.formlyService.text('email', $localize`Email`, undefined, { maxLength: 255 }),
        this.formlyService.checkbox('webAddress', $localize`Web Address`),
        this.formlyService.text('vatRegNo', $localize`Vat Registration Number`, undefined, {
          maxLength: 50,
        }),
        this.formlyService.checkbox('obsolete', $localize`Obsolete`),
      ],
      [
        this.formlyService.select('salesRegionId', $localize`Sales Region`, this.salesRegion$),
        this.formlyService.select('salesDiscountId', $localize`Sales Discount`, this.salesDiscount$),
        this.formlyService.select('customerTypeId', $localize`Customer Type`, this.customerType$),
        this.formlyService.select('customerSubTypeId', $localize`Customer Sub Type`, this.customerSubType$),
        this.formlyService.text('eoriNumber', $localize`EORI Number`),
      ],
    );
  }
}
